// import { useEffect, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, EffectCoverflow } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/effect-coverflow";
// import "./AlumniSpotlight.css";

// const alumniData = [
//     { id: 1, src: '../assets/alumni_spotlight_bg_removed/9.png', title: "Yash Aggarwal", slides: ["Yash1.png", "Yash2.png", "Yash3.png"] },
//     { id: 2, src: '../assets/alumni_spotlight_bg_removed/5.png', title: "Pulkit Jain" , slides: ["Jain1.png", "Jain2.png","Jain3.png"] },
//     { id: 3, src: '../assets/alumni_spotlight_bg_removed/4.png', title: "Moksh Thakral", slides: ["Moksh1.png", "Moksh2.png", "Moksh3.png"]  },
//     { id: 4, src: '../assets/alumni_spotlight_bg_removed/7.png', title: "Gauri Sharma",slides: ["Gauri1.png", "Gauri2.png", "Gauri3.png"] },
//     { id: 5, src: '../assets/alumni_spotlight_bg_removed/6.png', title: "Sanya Kumar" },
//     { id: 6, src: '../assets/alumni_spotlight_bg_removed/2.png', title: "Bhavya Arora",slides: ["Bhav1.png", "Bhav2.png", "Bhav3.png"] },
//     { id: 7, src: '../assets/alumni_spotlight_bg_removed/1.png', title: "Bhumika Aggarwal",slides: ["Bhumi1.png", "Bhumi2.png", "Bhumi3.pnhumi"] },
//     { id: 8, src: '../assets/alumni_spotlight_bg_removed/3.png', title: "Manas Khunger" },
//     { id: 9, src: '../assets/alumni_spotlight_bg_removed/8.png', title: "Tanay Suntwal",slides: ["Tanay1.png", "Tanay2.png", "Tanay3.png"] },
//     { id: 10, src: '../assets/alumni_spotlight_bg_removed/10.png', title: "Rajat Chabra",slides: ["Raj1.png", "Raj2.png", "Raj3.png"] },
//     { id: 11, src: '../assets/alumni_spotlight_bg_removed/12.png', title: "Yukta Mahajan",slides: ["Yukta1.png", "Yukta2.png", "Yukta3.png"] },
//     { id: 12, src: '../assets/alumni_spotlight_bg_removed/11.png', title: "Shlok Aggarwal", slides: ["Shlok1.png", "Shlok2.png", "Shlok3.png", "Shlok4.png", "Shlok5.png"] },
//     { id: 13, src: '../assets/alumni_spotlight_bg_removed/15.png', title: "Yusha Jamal", slides: ["Jamal1.png", "Jamal2.png", "Jamal3.png", "Jamal4.png"] },
//     { id: 14, src: '../assets/alumni_spotlight_bg_removed/13.png', title: "Dhriti Arora", slides: ["Dhriti1.png", "Dhriti2.png", "Dhriti3.png", "Dhriti4.png"] },
//     { id: 15, src: '../assets/alumni_spotlight_bg_removed/14.png', title: "Anoushka Mathur", slides: ["Mathur1.png", "Mathur2.png", "Mathur3.png", "Mathur4.png"] },
//   ];

// const AlumniSpotlight = () => {
//   const [swiperInstance, setSwiperInstance] = useState(null);
//   const [focusedAlumnus, setFocusedAlumnus] = useState(null);
//   const [showPopup, setShowPopup] = useState(false);
//   const [isClosing, setIsClosing] = useState(false);

//   useEffect(() => {
//     if (swiperInstance) {
//       swiperInstance.on("slideChange", () => {
//         const activeIndex = swiperInstance.realIndex;
//         setFocusedAlumnus(alumniData[activeIndex]);
//       });
//     }
//   }, [swiperInstance]);

//   const handleOpenPopup = () => {
//     setShowPopup(true);
//   };

//   const handleClosePopup = () => {
//     setIsClosing(true);
//     setTimeout(() => {
//       setShowPopup(false);
//       setIsClosing(false);
//     }, 500);
//   };

//   return (
//     <div className="alumni-spotlight">
//       <Swiper
//         modules={[Autoplay, EffectCoverflow]}
//         effect="coverflow"
//         grabCursor
//         centeredSlides
//         slidesPerView={2}
//         loop={true}
//         autoplay={{ delay: 2800, disableOnInteraction: false }}
//         coverflowEffect={{
//           rotate: 0,
//           stretch: 0,
//           depth: 150,
//           modifier: 2,
//           slideShadows: false,
//         }}
//         onSwiper={setSwiperInstance}
//       >
//         {alumniData.map((alumnus, index) => (
//           <SwiperSlide key={alumnus.id}>
//             {({ isActive }) => (
//               <div className={`carousel-item ${isActive ? "active" : "dimmed"}`}>
//                 <img src={alumnus.src} alt={alumnus.title} className="alumni-image" />
//                 <p className="alumni-title">{alumnus.title}</p>
//               </div>
//             )}
//           </SwiperSlide>
//         ))}
//       </Swiper>

//       {/* Read Spotlight Button */}
//       {focusedAlumnus && (
//         <button className="learn-more" onClick={handleOpenPopup}>
//           Read Spotlight
//         </button>
//       )}

//       {/* Popup */}
//       {showPopup && (
//         <div className="popup">
//           <div className={`popup-content ${isClosing ? "fade-out" : ""}`}>
//             <button className="close-btn" onClick={handleClosePopup}>
//               ✖ 
//             </button>
//             <h2>{focusedAlumnus?.title}</h2>
//             <div className="slides-container">
//               {focusedAlumnus?.slides.map((slide, index) => (
//                 <img key={index} src={`../assets/alumni_spotlight_bg_removed/${slide}`} alt={`Slide ${index + 1}`} className="slide-image" />
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AlumniSpotlight;


import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "./AlumniSpotlight.css";

const alumniData = [
    { id: 1, src: '../assets/alumni_spotlight_bg_removed/9.png', title: "Yash Aggarwal", slides: ["Yash1.png", "Yash2.png", "Yash3.png"] },
    { id: 2, src: '../assets/alumni_spotlight_bg_removed/5.png', title: "Pulkit Jain" , slides: ["Jain1.png", "Jain2.png","Jain3.png"] },
    { id: 3, src: '../assets/alumni_spotlight_bg_removed/4.png', title: "Moksh Thakral", slides: ["Moksh1.png", "Moksh2.png", "Moksh3.png"]  },
    { id: 4, src: '../assets/alumni_spotlight_bg_removed/7.png', title: "Gauri Sharma",slides: ["Gauri1.png", "Gauri2.png", "Gauri3.png"] },
    // { id: 5, src: '../assets/alumni_spotlight_bg_removed/6.png', title: "Sanya Kumar" },
    { id: 6, src: '../assets/alumni_spotlight_bg_removed/2.png', title: "Bhavya Arora",slides: ["Bhav1.png", "Bhav2.png", "Bhav3.png"] },
    { id: 7, src: '../assets/alumni_spotlight_bg_removed/1.png', title: "Bhumika Aggarwal",slides: ["Bhumi1.png", "Bhumi2.png", "Bhumi3.png"] },
    // { id: 8, src: '../assets/alumni_spotlight_bg_removed/3.png', title: "Manas Khunger" },
    { id: 9, src: '../assets/alumni_spotlight_bg_removed/8.png', title: "Tanay Suntwal",slides: ["Tanay1.png", "Tanay2.png", "Tanay3.png"] },
    { id: 10, src: '../assets/alumni_spotlight_bg_removed/10.png', title: "Rajat Chabra",slides: ["Raj1.png", "Raj2.png", "Raj3.png"] },
    { id: 11, src: '../assets/alumni_spotlight_bg_removed/12.png', title: "Yukta Mahajan",slides: ["Yukta1.png", "Yukta2.png", "Yukta3.png"] },
    { id: 12, src: '../assets/alumni_spotlight_bg_removed/11.png', title: "Shlok Aggarwal", slides: ["Shlok1.png", "Shlok2.png", "Shlok3.png", "Shlok4.png", "Shlok5.png"] },
    { id: 13, src: '../assets/alumni_spotlight_bg_removed/15.png', title: "Yusha Jamal", slides: ["Jamal1.png", "Jamal2.png", "Jamal3.png", "Jamal4.png"] },
    { id: 14, src: '../assets/alumni_spotlight_bg_removed/13.png', title: "Dhriti Arora", slides: ["Dhriti1.png", "Dhriti2.png", "Dhriti3.png", "Dhriti4.png"] },
    { id: 15, src: '../assets/alumni_spotlight_bg_removed/14.png', title: "Anoushka Mathur", slides: ["Mathur1.png", "Mathur2.png", "Mathur3.png", "Mathur4.png"] },
  ];

const AlumniSpotlight = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [focusedAlumnus, setFocusedAlumnus] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (swiperInstance) {
      swiperInstance.on("slideChange", () => {
        const activeIndex = swiperInstance.realIndex;
        setFocusedAlumnus(alumniData[activeIndex]);
      });
    }
  }, [swiperInstance]);

  const handleOpenPopup = () => {
    setShowPopup(true);
    if (swiperInstance) {
      swiperInstance.autoplay.stop();
    }
  };

  const handleClosePopup = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShowPopup(false);
      setIsClosing(false);
      if (swiperInstance) {
        swiperInstance.autoplay.start();
      }
    }, 500);
  };

  return (
    <div className="alumni-spotlight-container">
      <div className="alumni-spotlight-cards">
        <Swiper
          modules={[Autoplay, EffectCoverflow]}
          effect="coverflow"
          grabCursor
          centeredSlides
          slidesPerView={2}
          loop={true}
          autoplay={{ delay: 1800, disableOnInteraction: false }}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 150,
            modifier: 2,
            slideShadows: false,
          }}
          onSwiper={setSwiperInstance}
        >
          {alumniData.map((alumnus) => (
            <SwiperSlide key={alumnus.id}>
              {({ isActive }) => (
                <div className={`carousel-item ${isActive ? "active" : "dimmed"}`}>
                  <img src={alumnus.src} alt={alumnus.title} className="alumni-image" />
                  <p className="alumni-title">{alumnus.title}</p>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Read Spotlight Button */}
      {focusedAlumnus && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          className="learn-more"
          onClick={handleOpenPopup}
          style={{ marginLeft: '30px' }}
        >
          Read Spotlight
        </button>
      </div>
      )}

      {/* Popup */}
      {showPopup && (
        <div className="popup1">
          <div className={`popup1-content ${isClosing ? "fade-out" : ""}`}>
            <button className="close-btn" onClick={handleClosePopup}>✖</button>
            <h2>{focusedAlumnus?.title}</h2>
            <div className="slides-container">
              {focusedAlumnus?.slides?.map((slide, index) => (
                <img key={index} src={`../assets/alumni_spotlight_bg_removed/${slide}`} alt={`Slide ${index + 1}`} className="slide-image" />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AlumniSpotlight;
